import { proxyCustomElement, HTMLElement } from '@stencil/core/internal/client';
import './index2.js';
import { D as DomService } from './index3.js';

const RocheFoucPreventer$1 = /*@__PURE__*/ proxyCustomElement(class RocheFoucPreventer extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    componentDidLoad() {
        this.manageFouc();
    }
    /*
     * window.isPrerender is set on app.ts only on hydrate's runtime context.
     * It is specific to our app and not a stencil default.
     * More info https://stenciljs.com/docs/hydrate-app
     */
    manageFouc() {
        var _a, _b, _c;
        return ((_a = DomService.isMockedContext) === null || _a === void 0 ? void 0 : _a.call(DomService))
            ? (_b = document.documentElement) === null || _b === void 0 ? void 0 : _b.setAttribute('style', 'visibility: hidden;')
            : (_c = document.documentElement) === null || _c === void 0 ? void 0 : _c.removeAttribute('style');
    }
}, [1, "roche-fouc-preventer"]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-fouc-preventer"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-fouc-preventer":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheFoucPreventer$1);
            }
            break;
    } });
}

const RocheFoucPreventer = RocheFoucPreventer$1;
const defineCustomElement = defineCustomElement$1;

export { RocheFoucPreventer, defineCustomElement };

//# sourceMappingURL=roche-fouc-preventer.js.map